<div id="notfound">
  <div class="notfound">
    <div class="notfound-404">
      <h3>Oops! Products not found</h3>
      <h1><span>4</span><span>0</span><span>4</span></h1>
    </div>
    <h2>nothing found, try searching again</h2>
  </div>
</div>
